import { render, staticRenderFns } from "./HistoryManager.vue?vue&type=template&id=c37b0bac&scoped=true&"
import script from "./HistoryManager.vue?vue&type=script&lang=ts&"
export * from "./HistoryManager.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryManager.vue?vue&type=style&index=0&id=c37b0bac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37b0bac",
  null
  
)

export default component.exports